<div class="card size">
    <div class="card-body">
        <h1>Welcome, {{ this.inviteForm.value.name }}</h1>
        <p>Set up your user details in Biztory</p>
        <form [formGroup]='inviteForm' class='col-md-11 center'>
            <div class="form-group col">
                <label>{{ 'register.name' | translate }}</label>
                <input type="text" formControlName="name" class="form-control" placeholder='{{ "register.name" | translate }}' [ngClass]="{'input-error': userInfo.name.touched && userInfo.name.errors}">
                <div *ngIf="userInfo.name.touched && userInfo.name.errors" class="invalid-feedback">
                    <div *ngIf="userInfo.name.errors.required">{{ "register.name_err" | translate }}</div>
                </div>
            </div>
            <div class="form-group col">
                <label>{{ 'register.phone' | translate }}</label>
                <p>{{ 'register.phoneNum-desc' | translate }}</p>
                <input type="tel" formControlName="hp" class="form-control" placeholder="{{ 'register.phone' | translate }}" [ngClass]="{'input-error': userInfo.hp.touched && userInfo.hp.errors}">
                <div *ngIf="userInfo.hp.touched && userInfo.hp.errors" class="invalid-feedback">
                    <div *ngIf="userInfo.hp.errors.required">{{ 'register.phone_req' | translate }}</div>
                    <div *ngIf="userInfo.hp.errors.pattern">{{ 'register.phone_valid' | translate }}</div>
                </div>
            </div>
            <div class="form-group col">
                <label>{{ 'register.password' | translate }}</label>
                <input type="password" formControlName="password" class="form-control" placeholder="{{ 'register.password' | translate }}" [ngClass]="{'input-error': userInfo.password.touched && userInfo.password.errors}">
                <div *ngIf="userInfo.password.touched && userInfo.password.errors" class="invalid-feedback">
                    <div *ngIf="userInfo.password.errors.required">{{ 'register.password_req' | translate }}</div>
                    <div *ngIf="userInfo.password.errors.minlength">{{ 'register.password_valid' | translate }}</div>
                </div>
            </div>
            <div class="form-group col">
                <input type="password" formControlName="password_confirmation" class="form-control" placeholder="{{ 'register.confirm-password' | translate }}" [ngClass]="{'input-error': userInfo.password_confirmation.touched && userInfo.password_confirmation.errors}">
                <div *ngIf="userInfo.password_confirmation.touched && userInfo.password_confirmation.errors" class="invalid-feedback">
                    <div *ngIf="userInfo.password_confirmation.errors.required">{{ 'register.password_confirm_req' | translate }}</div>
                    <div *ngIf="userInfo.password_confirmation.errors.PasswordValidator">{{ 'register.password_confirm_valid' | translate }}</div>
                </div>
            </div>
            <div class="form-group col">
                <button type="submit" class="btn btn-primary btn-block" (click)="onSubmit()"><h3>{{ 'register.signinButton' | translate }}</h3></button>
                <p class="cardMargin">{{ 'register.accept-tof' | translate }} <a class='tof' href="http://www.biztory.com.my/term-of-service" target="_blank">{{ 'register.tof' | translate }}</a></p>
            </div>
            <div class="form-group col">
                <button type="button" class="btn btn-info btn-block" (click)="facebookSignup()"><img class="img-responsive" src="https://cdn1.iconfinder.com/data/icons/logotypes/32/square-facebook-512.png">{{ 'register.signinFB' | translate }}</button>
            </div>
        </form>
    </div>
</div> 